module.exports = __webpack_public_path__ + "static/media/pi.013ef905.jpg";